import AppRoutes from "../routing/routes";
import {
  watchLiveData,
  getStatus,
  sendGetRequest,
  formatDate,
  navigate,
  getActiveUser,
  sendDeleteRequest,
  allowedOperations
} from "../utils/utils";
import { useState, useEffect } from "react";
import DataListWithSearch from "./component/@list/list-search";
import { coreStyles } from "../theme/style";
import { Box, Button, ButtonGroup, Icon } from "@mui/material";
import { useSelector } from "react-redux";

const getTableHead = () => { 
  return [
    { id: "createdAt", label: "Purchased on",  align:'left'},
    { id: "transactionId", label: "Transaction ID",  align:'left'},
    { id: "from", label: "Purchased By",  align:'left'},
    { id: "package", label: "Package",  align:'left'},
    { id: "price", label: "Price", align:'left' },
    { id: "platform", label: "Platform", align:'left' },
    { id: "status", label: "Status", align:'left' }
  ];
};

const PaymentList = () => {
  const loggedUser = getActiveUser();
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
   const { queue } = useSelector((state) => state.queue);
  const appStyle = coreStyles();
  const { canDelete, canCreate } = allowedOperations();

  const userOptions = [
    canDelete ? {
      icon: "delete",
      value: "delete",
      label: "Delete",
      onClick: (value, selected) => {
        onLoading(true);
        Promise.all(selected.map(uuid => sendDeleteRequest('paywall', uuid))).then(response => {
          executeFetch();
        })
      }
    }: null,
  ].filter(Boolean);
  const filterOptions = [];

  const btnGroupOptions = [
    { label: "Payment Packages", destination: `${AppRoutes.payments}/${AppRoutes.packages}` },
    { label: "Free Trials", destination: `${AppRoutes.payments}/${AppRoutes.trials}` }
  ];

  const startEdit = (uuid) => navigate(`${AppRoutes.payments}/${AppRoutes.payment}${uuid ? `?uuid=${uuid}` : ''}`, true);

  const executeFetch = (refresh = false) => {
    sendGetRequest('paywall?metadata=true', (loading) => onLoading(refresh ? false: loading), (data) => 
    setDataList(data.map(_data => {
      return {
        uuid: _data.uuid,
        purchasedOn: _data.purchasedOn,
        email: _data.user.email,
        name: `${_data.user.firstName} ${_data.user.lastName}`,
        price: _data.price,
        duration: _data.package.duration,
        expired: _data.expired,
        transactionId: _data.transactionId ? _data.transactionId: "N/A",
        platform: _data.package.playstore ? "Android":"iOS",
        package: _data.package.storeRef
      }
    })));
  };

  useEffect(() => {
    executeFetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
      if (queue) watchLiveData(queue, "paywall", (_) => executeFetch(true));
      // eslint-disable-next-line
  }, [queue]);

  return (
    <div>
      <DataListWithSearch
        sectionTitle="Payment history"
        createNewElement={
          canCreate ? (<Box sx={{ display: "flex", flexDirection: "row" }}>
            <ButtonGroup size="large" aria-label="large button group">
              {btnGroupOptions.map((btn) => {
                return (
                  <Button
                    key={btn.destination}
                    onClick={() => navigate(
                      `${btn.destination}`,
                      true
                    )}
                  >
                    {btn.label}
                  </Button>
                );
              })}
            </ButtonGroup>
            <Button
              variant="contained"
              onClick={() => startEdit()}
              className={appStyle.actionButonCustom}
              startIcon={
                <Icon
                  children={"add"}
                  className={appStyle.actionButonIcon}
                />
              }
            >
              {loggedUser.active && canCreate ? "Clear payment" : null}
            </Button>
          </Box>): null
        }
        data={dataList}
        primaryKey="uuid"
        filterColumn={"email"}
        emptyIcon="receipt_long"
        avatarKey="uuid"
        loading={loading}
        headers={getTableHead()}
        rowData={(data) => {
          const _entries = [
            { value: formatDate(data.purchasedOn, "MMM DD, YYYY hh:mm A"), width: 200 },
            { value: data.transactionId},
            { value: `${data.email} (${data.name})`,},
            { value: data.package},
            { value: `$${data.price}` },
            { value: data.platform },
            { ...getStatus(data.expired ? "Expired":"Active")}
          ];
          return {
            exclude: [],
            entries: _entries,
          };
        }}
        selectionOptions={userOptions.filter((option) => option.value !== "edit")}
        filterOptions={filterOptions}
        optionItems={userOptions}
      />

    </div>
  );
};

export default PaymentList;
